import { useMutation, useQueryClient } from "@tanstack/react-query";
import * as yup from "yup";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";

const requestSchema = yup.object({
  code: yup.string().nullable(),
  state: yup.string().nullable(),
  isEnabled: yup.boolean().required(),
  syncAll: yup.boolean().required(),
  syncNew: yup.boolean().required(),
});

export function useSaveConstantContactAuthDataMutation(options = {}) {
  const queryClient = useQueryClient();

  return useMutation(
    (dto) => {
      const req = requestSchema.validateSync(dto, {
        strict: true,
      });
      return http.post(HTTP_ENDPOINTS.constantContact.saveAuthData(), {
        is_enabled: req.isEnabled ? 1 : 0,
        sync_all: req.syncAll ? 1 : 0,
        sync_new: req.syncNew ? 1 : 0,
        code: req.code || undefined,
        state: req.state || undefined,
      });
    },
    {
      ...options,
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.constantContact.authData],
        });
        options?.onSuccess?.();
      },
    },
  );
}
